import React from 'react';
import * as Styled from './style';
import demoImg from '../../assets/images/success1.png';
import setupImg from '../../assets/images/success2.png';
import feedbackImg from '../../assets/images/success3.png';

export default function AiChatbotSuccessContent() {
  return (
    <Styled.Container>
      <Styled.ContentBlock>
        <Styled.SectionWrapper>
          <Styled.TextWrapper>
            <h2>The demo call</h2>
            <p>
              During your demo, we’ll show you how our AI chatbot works, how it responds empathetically to your customer’s concerns, and how it will learn about your business. We’ll be able to answer any questions you might have about our white-glove setup protocol, the chatbot intake process, and anything else.
            </p>
            <p>
              You’ll receive an email with a pre-demo form asking some questions about your business, or you can start now by clicking the button below. This is the information we’ll be using to train your chatbot after the demo, so the sooner you fill this out, the sooner we’ll be able to set up your own version of the chatbot.
            </p>
            <Styled.Button to='/chatbot-business-questionnaire'>
              Customize My Chatbot
            </Styled.Button>
          </Styled.TextWrapper>
          <Styled.Image src={demoImg} alt='Demo call' />
        </Styled.SectionWrapper>
      </Styled.ContentBlock>

      <Styled.ContentBlock>
        <Styled.SectionWrapper reverse>
          <Styled.TextWrapper>
            <h2>After the demo</h2>
            <p>
              Once the demo call is complete, we’ll begin our setup process. Don’t worry, we’ll handle it all for you! During the setup window, we will:
            </p>
            <ul>
              <li>Train the chatbot on your firm’s information,</li>
              <li>Customize the chatbot with your firm’s brand, and</li>
              <li>Install it on your website.</li>
            </ul>
            <p>
              All absolutely free! Without lifting a finger, you’ll get an AI-powered chatbot on your website once we’re done setting everything up.
            </p>
          </Styled.TextWrapper>
          <Styled.Image src={setupImg} alt='After the demo' />
        </Styled.SectionWrapper>
      </Styled.ContentBlock>

      <Styled.ContentBlock>
        <Styled.SectionWrapper>
          <Styled.TextWrapper>
            <h2>We’ve got your back</h2>
            <p>
             Don’t worry! Once the chatbot is installed on your website, we’ll be around to help you in case you want to make any changes to the way it works! Whether you want to change the branded customization, update the information it learned, or address any other issue, our support team is always available to help resolve anything that might come up.
            </p>
          </Styled.TextWrapper>
          <Styled.Image src={feedbackImg} alt='Feedback process' />
        </Styled.SectionWrapper>
      </Styled.ContentBlock>
    </Styled.Container>
  );
}
